<template>
  <div id="app-center">
    <my-head></my-head>
    <center-head></center-head>
    <div class="center-box">
      <div class="center-list">
        <el-row :gutter="30">
          <el-col :span="4">
            <left-menu></left-menu>
          </el-col>

          <el-col :span="20">
            <div class="center-left">
              <el-card>
                <el-input
                  v-model="search.user_name"
                  placeholder="请输入姓名"
                  size="small"
                  style="width: 200px"
                  clearable
                ></el-input>
                <el-input
                  v-model="search.phone"
                  placeholder="请输入联系电话"
                  size="small"
                  style="width: 200px"
                  clearable
                ></el-input>
                <el-button
                  type="primary"
                  size="small"
                  icon="el-icon-search"
                  @click="$refs.tables.handleSearch()"
                >搜索</el-button>
              </el-card>

              <WtDataTable
                ref="tables"
                :search="search"
                :listUrl="$db.config.user.list"
                :delUrl="$db.config.user.delete"
              >
                <div slot="buttons">
                  <el-button
                    size="small"
                    style="margin-bottom:10px;"
                    icon="el-icon-plus"
                    type="primary"
                    @click="addUser"
                  >新增人员</el-button>
                </div>
                <template slot="columns">
                  <el-table-column label="姓名" min-width="100" align="center" prop="user_name"></el-table-column>

                  <el-table-column label="联系电话" prop="phone" align="center" min-width="100"></el-table-column>

                  <el-table-column label="职务" prop="duties" align="center" min-width="100"></el-table-column>

                  <el-table-column label="权限" prop="type_text" align="center" min-width="100"></el-table-column>

                  <el-table-column label="操作" min-width="120" align="center">
                    <template slot-scope="scope">
                      <el-button-group>
                        <el-button
                          type="primary"
                          icon="el-icon-edit"
                          size="mini"
                          :disabled="false"
                          @click="edit(scope.row)"
                        >编辑</el-button>

                        <el-button
                          v-if="scope.row.type !=4"
                          type="danger"
                          icon="el-icon-delete"
                          size="mini"
                          @click="handleDelete(scope.row.id)"
                        >删除</el-button>
                      </el-button-group>
                    </template>
                  </el-table-column>
                </template>
              </WtDataTable>

              <!-- 执行机构端人员新增、编辑 -->
              <el-dialog :visible.sync="userModal" :title="title" width="38%" @close="cancelBtn">
                <el-form
                  :model="userForm"
                  ref="formRef"
                  label-width="100px"
                  :rules="formRules"
                  class="demo-ruleForm"
                  style="width:96%"
                >
                  <el-form-item label="姓名" prop="user_name">
                    <el-input
                      v-model="userForm.user_name"
                      size="small"
                      placehoder="姓名"
                      style="width:85%"
                    ></el-input>
                  </el-form-item>

                  <el-form-item label="变更管理员" v-if="userForm.type == 4">
                    <p style="color:IndianRed">
                      注意：点击
                      <span
                        style="color:red;text-decoration: underline;cursor: pointer;"
                        @click="changeAdmin"
                      >变更管理员</span>，选择并保存后您将不会再拥有管理员权限
                    </p>
                    <el-select
                      v-if="selUserFlag"
                      v-model="userForm.admin_id"
                      placeholder="请选择新管理员"
                      style="width:85%"
                    >
                      <el-option
                        :label="item.user_name"
                        :value="item.id"
                        v-for="(item,index) in userList"
                        :key="index"
                        :disabled="item.id == userForm.id"
                      >
                        <span style="float: left">{{ item.user_name+"（"+item.phone+"）" }}</span>
                        <span
                          style="float: right; color: #8492a6; font-size: 13px"
                        >{{ item.duties }}</span>
                      </el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item label="权限" prop="type" v-else>
                    <el-select v-model="userForm.type" placeholder="请选择用户权限" style="width:85%">
                      <el-option
                        :label="item.label"
                        :value="item.value"
                        v-for="(item,index) in proUserType"
                        :key="index"
                      ></el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item label="联系电话" prop="phone">
                    <el-input
                      v-model="userForm.phone"
                      size="small"
                      type="number"
                      placehoder="联系电话"
                      style="width:85%"
                    ></el-input>
                  </el-form-item>

                  <el-form-item label="职务" prop="duties">
                    <el-input
                      v-model="userForm.duties"
                      size="small"
                      placehoder="职务"
                      style="width:85%"
                    ></el-input>
                  </el-form-item>

                  <el-form-item label="邮箱" prop="email">
                    <el-input
                      v-model="userForm.email"
                      size="small"
                      placehoder="邮箱"
                      style="width:85%"
                    ></el-input>
                  </el-form-item>

                  <el-form-item label="密码" v-if="!userForm.id">
                    <el-input
                      v-model="userForm.password"
                      type="password"
                      size="small"
                      placehoder="密码如果不填写,默认取手机后六位"
                      style="width:85%"
                    ></el-input>
                    <p>密码如果不填写,默认取手机后六位</p>
                  </el-form-item>

                  <el-form-item label="密码" v-else>
                    <el-input
                      v-model="userForm.password"
                      type="password"
                      size="small"
                      placehoder="编辑的时候空表示不修改密码，填写表示修改密码"
                      style="width:85%"
                    ></el-input>
                    <p>注意：编辑的时候空表示不修改密码，填写表示修改密码</p>
                  </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                  <el-button type="danger" size="small" icon="el-icon-close" @click="cancelBtn">关闭</el-button>
                  <el-button
                    type="primary"
                    size="small"
                    icon="el-icon-check"
                    @click="submitBtn"
                    :loading="loading"
                  >提交</el-button>
                </span>
              </el-dialog>
            </div>
          </el-col>
        </el-row>
      </div>
      <foot-div></foot-div>
    </div>
  </div>
</template>
<script>
import myHead from "../public/head";
import centerHead from "../public/center_head";
import leftMenu from "../public/menu";
import footDiv from "../public/foot";
export default {
  components: {
    myHead,
    centerHead,
    leftMenu,
    footDiv
  },
  data() {
    var checkPhone = (rule, value, callback) => {
      let mobile = /^[1][0-9]{10}$/;
      if (!mobile.test(value)) {
        return callback(new Error("手机号码格式不正确！"));
      } else {
        return callback();
      }
    };
    return {
      title: "事务代表新增",
      search: {},
      loading: false,
      userModal: false,
      selUserFlag: false, //显示选择管理员
      userList: [], //所有的人员
      proUserType: [
        { label: "公益负责人", value: 1 },
        { label: "众筹负责人", value: 2 },
        { label: "公益众筹负责人", value: 3 }
      ],
      userForm: {
        admin_id: null,
        id: null,
        user_name: "", //姓名
        phone: "", //电话
        duties: "", //职务
        type: null,
        email: "", //邮箱
        password: "" //密码
      },
      formRules: {
        user_name: [
          { required: true, message: "请输入姓名！", trigger: "blur" }
        ],
        phone: [{ required: true, trigger: "blur", validator: checkPhone }],
        type: [
          { required: true, trigger: "change", message: "请选择选择权限！" }
        ],
        email: [{ type: "email", trigger: "blur", message: "邮箱格式不正确！" }]
      }
    };
  },
  methods: {
    //添加工作人
    addUser() {
      this.userForm = {
        type: null,
        admin_id: null
      };
      this.title = "事务代表新增";
      this.userModal = true;
    },

    //变更管理员
    changeAdmin() {
      this.selUserFlag = true;
    },

    handleDelete(id) {
      this.$refs.tables.doDelete(id);
    },

    edit(row) {
      if (!row.id) {
        return this.$message.error("参数错误！");
      }
      this.$db
        .post(this.$db.config.UserManagementDetail, { id: row.id })
        .then(res => {
          if (res && res.code == 200) {
            this.title = "事务代表编辑";
            this.userForm = res.data;
            this.userModal = true;
          }
        });
    },
    cancelBtn() {
      this.userModal = false;
      this.$refs["formRef"].resetFields();
      this.selUserFlag = false;
    },
    //获取单位人员列表
    getUserList() {
      let data = { page: 1, page_size: 500 };
      this.$db.post(this.$db.config.user.list, data).then(res => {
        if (res && res.code == 200) {
          this.userList = res.data.data;
        }
      });
    },
    submitBtn() {
      this.loading = true;
      this.$refs["formRef"].validate(valid => {
        if (valid) {
          let url = "";
          if (this.userForm.id > 0) {
            url = this.$db.config.user.update;
          } else {
            url = this.$db.config.user.insert;
          }

          this.loading = true;
          if (this.userForm.admin_id) {
            this.$confirm(
              "变更管理人后需要新的管理员给您重新赋权才能正常使用",
              "变更提示",
              {
                type: "warning"
              }
            )
              .then(() => {
                this.$db.post(url, this.userForm).then(res => {
                  this.loading = false;
                  if (res && res.code == 200) {
                    this.$message.success(res.msg);
                    sessionStorage.removeItem("unitAuth");
                    location.reload();
                  }
                });
              })
              .catch(() => {});
          } else {
            this.$db.post(url, this.userForm).then(res => {
              this.loading = false;
              if (res && res.code == 200) {
                this.$message.success(res.msg);
                this.cancelBtn();
                this.$refs.tables.reloadData();
              }
            });
          }
        } else {
          this.loading = false;
          this.$message.warning("请填写完整信息！");
        }
      });
    }
  },
  created() {
    this.getUserList();
  }
};
</script>
<style lang="scss" scoped>
#app-center {
  width: 100%;
  background-color: #f1f1f1;
}
.center-box {
  .center-list {
    margin: 0 auto;
    width: 98%;
    padding-top: 20px;
    .center-left {
      background-color: #fff;
      border-top: 2px solid #b60205;
      padding-top: 30px;
      overflow: hidden;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Hospital/user/list.vue